<template>
  <div class="con clearfix">
    <div class="left font12 font_weight400 colo055 color_select">买家评论</div>
    <div class="left font12 font_weight400 colo087 color_select">
      暂无评论
    </div>
    <img
      src="@/assets/common/icon_back_b87_24@2x.png"
      alt=""
      class="right color_right"
    />
  </div>
</template>

<script>
export default {
  name: "BuyerReviews",
  methods: {}
};
</script>

<style lang="less" scoped>
.con {
  padding: 7px 0 6px;
  .color_select {
    line-height: 17px;
    margin: 4px 20px 0 0;
  }
  .color_right {
    width: 24px;
  }
}
</style>
